import React from "react";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import IotCallingForm from "../form/IotCallingForm/IotCallingForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit IotCalling" : "Create IotCalling";
};

const IotCallingPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  return (
    <RightSideModel
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      title={titlePopup(Boolean(recordForEdit))}
    >
      <IotCallingForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />
    </RightSideModel>
  );
};

export default IotCallingPopup;
